import AttendanceSerializer from './base';

export default class DayCode extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      lateCount: 0,
      partialAbsences: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
